import { Provider } from 'react-redux';
import { createStore } from 'redux';
import React from 'react';
import ReactDOM from 'react-dom';
import { loadableReady } from '@loadable/component';
import { onCLS, onFID, onLCP } from 'web-vitals';
import '@fortawesome/fontawesome-free/css/all.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import './fonts.css';
import App from './App';

import todoApp from './reducers';

const AppWrapper = ({ children }) => {
  const store = createStore(todoApp);

  return (<Provider store={store}>{children}</Provider>);
};

loadableReady(() => {
  ReactDOM.render(
    <AppWrapper>
      <App />
    </AppWrapper>,
    document.getElementById('root'),
  );
});

onCLS(console.log.bind(console, 'CLS'));
onFID(console.log.bind(console, 'FID'));
onLCP(console.log.bind(console, 'LCP'));
